import React from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import Content from 'components/Content';
import { config } from 'config';
import { find, filter, reduceRight } from 'lodash';
import './foo.css';

const propTypes = {
    router: React.PropTypes.object,
};

const SIDEBAR_SUFFIX = '.sidebar';

export default function MarkdownWrapper({ route }) {
    const post = route.page.data;
    let backLink;

    const splitPath = route.path && route.path.split('/').filter(i => i);

    if (splitPath) {
        splitPath.pop();
        const goBack = splitPath && splitPath.length > 1;
        backLink = reduceRight(
            splitPath,
            (path, level) => {
                return level + '/' + path;
            },
            ''
        );
    }

    let sidebar = find(route.pages, page => {
        return page.file.name === route.page.file.name + SIDEBAR_SUFFIX;
    });

    const events =
        post.category &&
        filter(
            route.pages,
            page =>
                page.data.eventType === post.category ||
                (Array.isArray(page.data.eventType) && page.data.eventType.indexOf(post.category) !== -1)
        );

    return (
        <Content
            sidebar={sidebar && <span dangerouslySetInnerHTML={{ __html: sidebar.data.body }} />}
            events={events}
            soundcloud={post.soundcloud}
            youtube={post.youtube}
            youtubeList={post.youtubeList}
        >
            <Helmet title={`${config.siteTitle} | ${post.title}`} />
            {backLink ? <Link to={backLink}>Zurück</Link> : null}
            {post.formattedTitle
                ? <h1 dangerouslySetInnerHTML={{ __html: post.formattedTitle }} />
                : <h1 dangerouslySetInnerHTML={{ __html: post.title }} />}

            <div dangerouslySetInnerHTML={{ __html: post.body }} />
        </Content>
    );
}

MarkdownWrapper.propTypes = propTypes;



// WEBPACK FOOTER //
// ../wrappers/md.js